import { computed, defineComponent, onMounted, ref } from "vue";
import { MemberApi, ProductApi } from "@/services/Api";
import { BasketApi, } from "@/services/Api";
import { useAsyncSpinner } from "@/services/Spinner";
import { Order, OrderList } from "@/models/Order";
import CustomPagination from "@/components/CustomPagination.vue";
import { Pagination, PaginationItem } from "@/models/Pagination";
import { useCart } from "@/store/useCart";
import { Customer } from "@/models/Customer";

export default defineComponent({
  props: {
    checkoutpageurl:{
      type: String,
      required: true
    }
  },
  components: {
    CustomPagination,
  },
  setup(props) {
    let currentPage = 1;
    const paginationKey = ref(0);
    const customer = ref<Customer | null>(null);
    const order = ref<Order>();
    const processing = ref<boolean>(false);
    const isReseller = ref<boolean>(false);
    const isContract = ref<boolean>(false);
    const history = ref<OrderList>();
    const noResults = ref<boolean>(false);
    const isLoading = ref<boolean>(true);
    const showHistory = computed<boolean>(
      () => history.value !== undefined && order.value === undefined
    );
    const cart = useCart();

    const pagination = computed<Pagination>(() => {
      const pagination: Pagination = {
        maxShow: 25,
        items: [] as Array<PaginationItem>,
      };
      if (history.value === undefined) {
        return pagination;
      }
      const items = [] as Array<PaginationItem>;
      for (let i = 1; i <= history.value.totalPages; i++) {
        items.push({ name: i.toString(), value: i.toString() });
      }
      pagination.items = items;
      return pagination;
    });

    const loadHistory = async (): Promise<void> => {
      await useAsyncSpinner(async () => {
        history.value = await MemberApi.getOrderHistory(currentPage);
      });
    };

    const getCustomer = async (): Promise<void> => {
      const fetchedCustomer = await MemberApi.getCustomer();
      customer.value = fetchedCustomer;
      if (fetchedCustomer.company) {
        if (fetchedCustomer.company.companyType == "ÅF") {
          isReseller.value = true;
          isContract.value = false;
        } else if (fetchedCustomer.company.companyType == "Avtal") {
          isContract.value = true;
          isReseller.value = false;
        }
      } else {
        isReseller.value = false;
        isContract.value = false;
      }
    };

    const onPaginationClick = async (
      _: number,
      value: string
    ): Promise<void> => {
      currentPage = parseInt(value, 10);
      await loadHistory();
    };

    const showOrder = async (showOrder: Order): Promise<void> => {
      await showOrder.items.forEach(async (element) => {
        const isBulk = await ProductApi.isProductBulk(element.partNo);
        if (isBulk) {
          element.isBulk = true;
        }
      });
      order.value = showOrder;
      window.scrollTo(0, 0);
    };

    const hideOrder = async (): Promise<void> => {
      order.value = undefined;
      currentPage = 1;
      await loadHistory();
    };

    const orderAgain = async (order: Order): Promise<void> => {
      processing.value = true;
      await useAsyncSpinner(async () => {
        await BasketApi.createBasketFromOrder(order.basketId);
        await cart.load();

        if (props.checkoutpageurl) {
          location.assign(window.location.origin + props.checkoutpageurl);
        } else {
          const e = document.getElementById('cart')
          const miniCart = document.getElementById('miniCartWrap')
          e?.classList.add('shake')
          miniCart?.classList.add('toggle')
  
          setTimeout(() => {
            e?.classList.remove('shake')
            miniCart?.classList.remove('toggle')
          }, 2000);
        }
        
        processing.value = false;
      });
    };

    onMounted(async () => {
      isLoading.value = true;
      await getCustomer();
      await loadHistory();
      isLoading.value = false;
    });

    return {
      order,
      pagination,
      showHistory,
      processing,
      onPaginationClick,
      showOrder,
      hideOrder,
      orderAgain,
      customer,
      isReseller,
      isContract,
      noResults,
      currentPage,
      paginationKey,
      isLoading,
      history
    };
  },
});